import React from 'react'

const QuizWhiz = () => {
  return (
    <div>QuizWhiz</div>
  )
}

export default QuizWhiz